<template>
  <div class="login_in" :id="nodeName">
    <!--关联手机号-->
    <div>
      <h4>{{title}}</h4>
      <el-form v-show="registrationMethod" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px"
        class="ruleForm">
        <p style="float:left;paddingLeft:10px">手机号</p>
        <el-form-item label prop="loginPhone">
          <el-input v-model.number="ruleForm.loginPhone"></el-input>
        </el-form-item>

        <p style="text-align: left;paddingLeft:10px">验证码</p>
        <el-form-item label prop="numCode" class="verification">
          <el-col :span="15">
            <el-input :class="['numCode', {load: validCode._load}]" v-model.number="ruleForm.numCode"></el-input>
          </el-col>
          <el-col class="line" :span="1">&nbsp;</el-col>
          <el-col :span="7">
            <el-button type="info" plain style="width: 101px;" :loading="validCode._load" :disabled="validCode.disabled"
              @click="getVerificationCode">{{validCode._html}}</el-button>
          </el-col>
        </el-form-item>
        <p style="float:left;paddingLeft:10px">设置密码</p>
        <el-form-item label prop="password">
          <el-input type="password" v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item style="paddingTop:10px">
          <el-button type="primary" class="login" @click="signIn">登录</el-button>
        </el-form-item>
      </el-form>

      <el-form v-show="!registrationMethod" :model="ruleFormEmail" status-icon :rules="rulesEmail" ref="ruleFormEmail"
        label-width="0px" class="ruleForm">
        <p style="float:left;paddingLeft:10px">邮箱</p>
        <el-form-item label prop="email">
          <el-input v-model="ruleFormEmail.email"></el-input>
        </el-form-item>

        <p style="text-align: left;paddingLeft:10px">验证码</p>
        <el-form-item label prop="numCode" class="verification">
          <el-col :span="15">
            <el-input :class="['numCode', {load: validCode._load}]" v-model.number="ruleFormEmail.numCode"></el-input>
          </el-col>
          <el-col class="line" :span="1">&nbsp;</el-col>
          <el-col :span="7">
            <el-button type="info" plain style="width: 101px;" :loading="validCode._load" :disabled="validCode.disabled"
              @click="getVerificationCode">{{validCode._html}}</el-button>
          </el-col>
        </el-form-item>
        <p style="float:left;paddingLeft:10px">设置密码</p>
        <el-form-item label prop="password">
          <el-input type="password" v-model="ruleFormEmail.password"></el-input>
        </el-form-item>
        <el-form-item style="paddingTop:10px">
          <el-button type="primary" class="login" @click="signIn">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="previousStep">
      <span @click="iswitch" style="paddingRight:10px">{{titleName}}</span>
      <span @click="previousStep" style="paddingRight:10px">上一步</span>
    </div>

  </div>
</template>
<script>
import md5 from "js-md5";
import qs from "qs";
export default {

  props: ['userId'],
  data () {

    return {
      //表单验证规则
      rules: {
        loginPhone: [{ required: true, validator: isPhone, trigger: "blur" }],
        numCode: [{ required: true, message: "*请输入验证码", trigger: "blur" }],
        password: [{ validator: isPassword, trigger: "blur" }],

      },
      //表单数据
      ruleForm: {
        loginPhone: '',
        numCode: '',
        password: ''
      },
      //表单验证规则
      rulesEmail: {
        email: [{ required: true, validator: isEmail, trigger: "blur" }],
        numCode: [{ required: true, message: "*请输入验证码", trigger: "blur" }],
        password: [{ validator: isPassword, trigger: "blur" }],

      },
      //表单数据
      ruleFormEmail: {
        email: '',
        numCode: '',
        password: ''
      },
      // 
      validCode: {
        timeMax: 60,
        html: "获取验证码",
        load: "{time}秒后重试",
        _html: "获取验证码",
        _load: false,
        _time: 60,
        _inter: null,
        disabled: false
      },
      disabled: true,
      nodeName: "",
      registrationMethod: true,// 注册方式
    };
  },
  computed: {
    title () {
      return this.registrationMethod ? "关联手机号" : "关联邮箱"
    },
    titleName () {
      return this.registrationMethod ? "关联邮箱" : "关联手机号"
    },
  },
  created () {
    this.nodeName = process.env.VUE_APP_NAME;
    // let myUserName = localStorage.getItem("myUserName");
    // if (!myUserName) {
    //   this.$router.push({ name: "login_in" })
    // }
  },
  mounted () {
    if (this.$route.params.userId !== '123') {
      this.$router.replace({ name: "login_in" })
    }

  },
  methods: {
    // 切换关联方式
    iswitch () {
      if (this.registrationMethod) {
        this.$refs['ruleFormEmail'].resetFields();
        this.$refs['ruleForm'].resetFields();
        this.registrationMethod = !this.registrationMethod
      } else {
        this.$refs['ruleFormEmail'].resetFields();
        this.$refs['ruleForm'].resetFields();
        this.registrationMethod = !this.registrationMethod
      }
    },
    // 获取验证码
    getVerificationCode () {
      let verify = true
      if (this.registrationMethod) {
        this.$refs.ruleForm.validateField(["loginPhone"], errTip => {
          if (errTip) {
            // 会调用多次
            verify = false;
          }
        });
      } else {
        this.$refs.ruleFormEmail.validateField(["email"], errTip => {
          if (errTip) {
            // 会调用多次
            verify = false;
          }
        });
      }
      if (verify) {
        if (this.registrationMethod) {
          //携带参数
          var params = {
            // oldPhone: this.scopedForm.oldPhone,
            loginPhone: this.ruleForm.loginPhone,

          };
          this.catReq1Service("/api/v1/sms/send_verifyCode", params)// 获取验证码
            .then(response => {
              let that = this
              if (!response.success) {
                return;
              }
              // 开启登录计时
              this.startCountdown();
              if (response.success) {
                // 登录可以点击
                that.disabled = false
              }
            })
            .catch(error => {

            });
        } else {
          let params = {
            email: this.ruleFormEmail.email,
            platformType: 0
          }
          this.catReq1Service("/user/send_email_code", params).then(response => {
            if (!response.success) {
              return;
            }
            // 开启登录计时
            this.startCountdown();
            if (response.success) {
              // 登录可以点击
              that.disabled = false
            }
          })
            .catch(error => {
              console.log(error);
            });
        }

      }

    },

    startCountdown () {
      clearInterval(this._inter);
      this.validCode.disabled = true;
      this.startCountdownCore();
      this._inter = setInterval(() => {
        this.startCountdownCore();
        if (this.validCode._time <= 0) {
          this.endCountdown();
        }
      }, 1000);
    },
    startCountdownCore () {
      this.validCode._time--;
      this.validCode._html = this.validCode.load.replace(
        /\{time\}/g,
        ("0000" + this.validCode._time).substr(-2, 2)
      );
    },
    endCountdown () {
      clearInterval(this._inter);
      this.validCode.disabled = false;
      this.validCode._html = this.validCode.html; // 获取验证码
      this.validCode._time = this.validCode.timeMax; // 60
      this.validCode._load = false;
      this.validCode._inter = null;
    },

    // //登录
    signIn () {
      let that = this;
      let verify = true
      if (this.registrationMethod) {
        this.$refs.ruleForm.validateField(["loginPhone", "numCode", "password"], errTip => {
          if (errTip) {
            // 会调用多次    numCode: '',

            verify = false;
          }
        });
      } else {
        this.$refs.ruleFormEmail.validateField(["email", "numCode", "password"], errTip => {
          if (errTip) {
            // 会调用多次
            verify = false;
          }
        });
      }
      if (verify) {
        if (this.registrationMethod) {
          let params = {
            loginPhone: this.ruleForm.loginPhone,
            verificationCode: this.ruleForm.numCode,
            password: md5(this.ruleForm.password)
          };
          this.catReq1Service("/api/v1/user/signIn_telephone", params)
            .then(response => {
              if (!response.success) {
                return;
              }
              localStorage.setItem("myPhone", this.ruleForm.loginPhone); // 电话 
              if (response.success) {
                // 登录可以点击
                that.$router.replace({ name: "home" })
              }
            })
            .catch(error => {

            });

        } else {
          let params = {
            email: this.ruleFormEmail.email,
            verificationCode: this.ruleFormEmail.numCode,
            password: md5(this.ruleFormEmail.password),
            platformType: 0
          };
          this.catReq1Service("/api/v1/user/signIn_email", params)
            .then(response => {
              if (!response.success) {
                return;
              }
              localStorage.setItem("myEmail", this.ruleFormEmail.email); // 电话 
              if (response.success) {
                // 登录可以点击
                that.$router.replace({ name: "home" })
              }
            })
            .catch(error => {

            });
        }
      }


    },


    // 上一步
    previousStep () {
      this.$emit("func", 0)
      // this.$router.replace({ name: "login_in" })
    }
  },

};
function isPassword (rule, value, next) {
  if (value === "") {
    next(new Error("请输入密码"));
  } else if (value.length < 6) {
    next(new Error("密码长度不能小于6个字符"));
  } else if (value.length > 16) {
    next(new Error("密码长度不能超过16个字符"));
  }
  next();
}
function isPhone (rule, value, next) {
  var reg = /^1\d{10}$/;
  if (value === "" || value == void 0) {
    next("*请输入手机号");
  } else if (!reg.test(value)) {
    next("*请输入正确的手机号");
  } else {
    next();
  }
}
function isEmail (rule, value, next) {
  let email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  if (value === "" || value == void 0) {
    next("*请输入邮箱");
  } else if (!email.test(value)) {
    next("*请输入正确的邮箱");
  } else {
    next();
  }
}
</script>
<style lang="less" scoped>
/* 增量训练start */
#drill {
  h4 {
    color: rgba(33, 71, 145, 1);
  }
  .ruleForm {
    button {
      background: rgba(41, 185, 147, 1);
      border: 0px;
      color: white;
    }
    /deep/.el-input__inner {
      color: rgba(76, 129, 184, 1);
    }
    .login {
      background: rgba(49, 111, 209, 1);
    }
  }
  .previousStep {
    color: rgba(32, 75, 163, 1);
  }
}
/* 增量训练end */
.login_in {
  // width: 300px;
  // background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 10px 10px 0px rgba(137, 137, 137, 0.13);
  border-radius: 10px;
  padding: 70px 80px 0 80px;
  position: relative;
  h4 {
    text-align: center;
    font-weight: 700;
    color: #000;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    padding: 10px;
    margin-bottom: 40px;
    span:nth-child(1) {
      float: left;
    }
    span:nth-child(2) {
      float: right;
    }
    .log_act {
      color: rgba(0, 0, 0, 1);
      font-size: 18px;
    }
  }
  .ruleForm {
    text-align: center;
    margin-top: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    p {
      margin-bottom: 5px;
    }
    /deep/.el-input__inner {
      height: 36px;
      line-height: 36px;
      border: 1px solid rgba(192, 192, 192, 1);
      border-radius: 2px;
    }
    // button {
    //   width: 304px;
    //   height: 36px;
    //   // background: rgba(64, 158, 255, 1);
    //   //border-radius: 2px;
    //   line-height: 0px;
    //   padding: 7px 8px;
    // }
    .verification {
      button {
        // position: relative;
        // left: 0px;
        // width: 96px;
        // height: 34px;
        width: 304px;
        height: 36px;
        background: #568aec;
        // border: 1px solid #454545;
        border-radius: 2px;
        color: #ffffff;
        padding: 0px;
      }
      // button:hover {
      //   background: #f1f1f1;
      //   border: 1px solid #454545;
      //   color: #454545;
      // }
      // button:active {
      //   background: #454545;
      //   color: #ffffff;
      // }
    }
    button {
      width: 280px;
      height: 36px;
      border: 0;
      background: #2270e5;
      border-radius: 2px;
      line-height: 0px;
      color: #ffffff;
    }
    // button:hover {
    //   background: #3e3e3e;
    // }
    // button:press {
    //   background: #333333;
    // }
    .register {
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(192, 192, 192, 1);
      color: rgba(69, 69, 69, 1);
    }
    .el-form-item {
      margin-bottom: 24px;
    }
  }
  .weixing {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // #wxImg {
    //   width: 250px;
    //   height: 250px;
    //   border: 1px solid rgba(167, 167, 167, 1);
    //   border-radius: 4px;
    // }
    p {
      position: relative;
      top: 10px;
      left: -40px;
      font-size: 12px;
    }
  }
  .previousStep {
    width: 75%;
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 50px;
    font-size: 12px;
    color: #204ca4;
    span {
      cursor: pointer;
    }
  }
  .previousStep:hover {
    color: #999998;
  }
}
</style>
<style lang="less">
#wx_default_tip {
  display: none;
}
.status_browser {
  display: none;
}
</style>